module.exports = __webpack_public_path__ + "grenada.svg?b1f94ed8a580637b2d973865d9eb931d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/grenada.svg
// module id = 178
// module chunks = 10